// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activity-bar {
  width: var(--activity-bar-width);
  background: var(--bg-secondary);
  border-right: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
  flex-shrink: 0;
  z-index: 10;
}

.activity-bar-top,
.activity-bar-bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.activity-bar-mobile { display: none; }

.activity-bar-btn {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
  border-radius: 0;
  position: relative;
  transition: color 0.15s;
}
.activity-bar-btn:hover { color: var(--text-primary); }
.activity-bar-btn.active { color: var(--text-primary); }
.activity-bar-btn.has-sublabel { flex-direction: column; gap: 2px; height: 56px; }
.activity-bar-sublabel {
  font-size: 9px;
  font-weight: 700;
  color: #4fc1ff;
  letter-spacing: 0.4px;
  line-height: 1;
  pointer-events: none;
  /* Ship names (projects without NB number) must fit the narrow bar */
  max-width: 44px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.activity-bar-btn.active::before {
  content: '';
  position: absolute;
  left: 0; top: 8px; bottom: 8px;
  width: 2px;
  background: var(--section-color, var(--text-primary));
  border-radius: 0 2px 2px 0;
}

.mobile-menu-backdrop { display: none; }
.mobile-menu { display: none; }

@media (max-width: 768px), (hover: none) and (max-width: 1024px) {
  .activity-bar {
    position: fixed;
    bottom: 0; left: 0; right: 0;
    width: 100%;
    height: 56px;
    flex-direction: row;
    border-right: none;
    border-top: 1px solid var(--border);
    padding: 0;
    z-index: 100;
  }
  .activity-bar-top, .activity-bar-bottom { display: none; }
  .activity-bar-mobile {
    display: flex;
    flex: 1;
    flex-direction: row;
  }
  .activity-bar-btn { flex: 1; width: auto; height: 56px; }
  .activity-bar-btn.active::before {
    left: 25%; right: 25%;
    top: auto; bottom: 0;
    width: auto; height: 2px;
    border-radius: 2px 2px 0 0;
  }
  .mobile-menu-backdrop {
    display: block;
    position: fixed; inset: 0; z-index: 98;
  }
  .mobile-menu {
    display: flex;
    flex-direction: column;
    position: fixed;
    bottom: 56px; right: 0;
    z-index: 99;
    background: var(--bg-secondary);
    border: 1px solid var(--border);
    border-radius: 6px 0 0 0;
    min-width: 170px;
    padding: 4px 0;
    box-shadow: -2px -2px 12px rgba(0,0,0,0.4);
  }
  .mobile-menu-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 13px 18px;
    font-size: 13px;
    color: var(--text-secondary);
  }
  .mobile-menu-item:hover { background: var(--bg-hover); color: var(--text-primary); }
  .mobile-menu-item.active { color: var(--section-color, var(--text-primary)); }
  .mobile-menu-divider {
    height: 1px;
    background: var(--border);
    margin: 4px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/ActivityBar.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,cAAc;EACd,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,uBAAuB,aAAa,EAAE;;AAEtC;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;AACA,0BAA0B,0BAA0B,EAAE;AACtD,2BAA2B,0BAA0B,EAAE;AACvD,iCAAiC,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE;AACjF;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,oBAAoB;EACpB,oEAAoE;EACpE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO,EAAE,QAAQ,EAAE,WAAW;EAC9B,UAAU;EACV,qDAAqD;EACrD,0BAA0B;AAC5B;;AAEA,wBAAwB,aAAa,EAAE;AACvC,eAAe,aAAa,EAAE;;AAE9B;EACE;IACE,eAAe;IACf,SAAS,EAAE,OAAO,EAAE,QAAQ;IAC5B,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,mCAAmC;IACnC,UAAU;IACV,YAAY;EACd;EACA,0CAA0C,aAAa,EAAE;EACzD;IACE,aAAa;IACb,OAAO;IACP,mBAAmB;EACrB;EACA,oBAAoB,OAAO,EAAE,WAAW,EAAE,YAAY,EAAE;EACxD;IACE,SAAS,EAAE,UAAU;IACrB,SAAS,EAAE,SAAS;IACpB,WAAW,EAAE,WAAW;IACxB,0BAA0B;EAC5B;EACA;IACE,cAAc;IACd,eAAe,EAAE,QAAQ,EAAE,WAAW;EACxC;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,YAAY,EAAE,QAAQ;IACtB,WAAW;IACX,+BAA+B;IAC/B,+BAA+B;IAC/B,wBAAwB;IACxB,gBAAgB;IAChB,cAAc;IACd,0CAA0C;EAC5C;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,4BAA4B;EAC9B;EACA,0BAA0B,2BAA2B,EAAE,0BAA0B,EAAE;EACnF,2BAA2B,gDAAgD,EAAE;EAC7E;IACE,WAAW;IACX,yBAAyB;IACzB,aAAa;EACf;AACF","sourcesContent":[".activity-bar {\n  width: var(--activity-bar-width);\n  background: var(--bg-secondary);\n  border-right: 1px solid var(--border);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding: 4px 0;\n  flex-shrink: 0;\n  z-index: 10;\n}\n\n.activity-bar-top,\n.activity-bar-bottom {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n}\n\n.activity-bar-mobile { display: none; }\n\n.activity-bar-btn {\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted);\n  border-radius: 0;\n  position: relative;\n  transition: color 0.15s;\n}\n.activity-bar-btn:hover { color: var(--text-primary); }\n.activity-bar-btn.active { color: var(--text-primary); }\n.activity-bar-btn.has-sublabel { flex-direction: column; gap: 2px; height: 56px; }\n.activity-bar-sublabel {\n  font-size: 9px;\n  font-weight: 700;\n  color: #4fc1ff;\n  letter-spacing: 0.4px;\n  line-height: 1;\n  pointer-events: none;\n  /* Ship names (projects without NB number) must fit the narrow bar */\n  max-width: 44px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.activity-bar-btn.active::before {\n  content: '';\n  position: absolute;\n  left: 0; top: 8px; bottom: 8px;\n  width: 2px;\n  background: var(--section-color, var(--text-primary));\n  border-radius: 0 2px 2px 0;\n}\n\n.mobile-menu-backdrop { display: none; }\n.mobile-menu { display: none; }\n\n@media (max-width: 768px), (hover: none) and (max-width: 1024px) {\n  .activity-bar {\n    position: fixed;\n    bottom: 0; left: 0; right: 0;\n    width: 100%;\n    height: 56px;\n    flex-direction: row;\n    border-right: none;\n    border-top: 1px solid var(--border);\n    padding: 0;\n    z-index: 100;\n  }\n  .activity-bar-top, .activity-bar-bottom { display: none; }\n  .activity-bar-mobile {\n    display: flex;\n    flex: 1;\n    flex-direction: row;\n  }\n  .activity-bar-btn { flex: 1; width: auto; height: 56px; }\n  .activity-bar-btn.active::before {\n    left: 25%; right: 25%;\n    top: auto; bottom: 0;\n    width: auto; height: 2px;\n    border-radius: 2px 2px 0 0;\n  }\n  .mobile-menu-backdrop {\n    display: block;\n    position: fixed; inset: 0; z-index: 98;\n  }\n  .mobile-menu {\n    display: flex;\n    flex-direction: column;\n    position: fixed;\n    bottom: 56px; right: 0;\n    z-index: 99;\n    background: var(--bg-secondary);\n    border: 1px solid var(--border);\n    border-radius: 6px 0 0 0;\n    min-width: 170px;\n    padding: 4px 0;\n    box-shadow: -2px -2px 12px rgba(0,0,0,0.4);\n  }\n  .mobile-menu-item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 13px 18px;\n    font-size: 13px;\n    color: var(--text-secondary);\n  }\n  .mobile-menu-item:hover { background: var(--bg-hover); color: var(--text-primary); }\n  .mobile-menu-item.active { color: var(--section-color, var(--text-primary)); }\n  .mobile-menu-divider {\n    height: 1px;\n    background: var(--border);\n    margin: 4px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
